
import { Component, Vue, Prop } from "vue-property-decorator";
import CaseItemM from "./components/CaseItemM.vue";
import { getCaseDetail, getCaseList } from "@/apis/about";
import Pagination from "@/components/pagination.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {
    CaseItemM,
    Pagination,
    Breadcrumb
  }
})
export default class Case extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  total = 1;

  per_page = 12;
  list: any = [];
  page: any = 0;
  id: any = "";
  List = [
    { title: "关于光华", url: "" },
    { title: "客户案例", url: "/case" },
    { title: "案例详情", url: "" }
  ];
  info = {};
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id || "";
    }
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.page = this.page == 0 ? 1 : this.page;
    this.getCaseList();
    this.getCaseDetail();
  }
  handlePageChange(val: any) {
    this.page = val.page;
    this.getCaseList();
  }
  async getCaseList() {
    const { data, total } = await getCaseList({
      page: this.page,
      per_page: this.per_page
    });
    this.list = data;
    this.list.map((item: any) => {
      item.thumb_url = item.thumb_url
        ? item.thumb_url
        : "/gh_website/img-default.png";
    });
    this.total = total;
  }

  async getCaseDetail() {
    const data = await getCaseDetail({
      id: this.id
    });
    this.info = data;
  }
  clickCase(item: any) {
    this.id = item.case_id;
    this.getCaseDetail();
    // this.$router.replace(`/case-detail?id=${item.id}&page=${this.page}`);
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
}
